import { render } from "./ViewComposition.vue?vue&type=template&id=3b7e8db4&ts=true"
import script from "./ViewComposition.vue?vue&type=script&lang=ts"
export * from "./ViewComposition.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__